<template>
  <v-app id="inspire">
    <div class="clients-wrap">
      <div>
        <h2 class="headline">Unassigned</h2>
      </div>
      <div class="header-search-single">
        <div class="inv-wrap-search">
          <v-text-field
            class="inv-search-field"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            v-model="search"
            @input="typing = true"
          >
          </v-text-field>
        </div>
      </div>
      <!-- Edit Dialog Wiew  -->
      <v-card>
        <!-- tools table -->
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          loader-height="2"
          :footer-props="{'items-per-page-options': [10, 20]}"
          class="elevation-1 table-org my-sticky-last-column-table"
          :header-props="{ 'sort-icon': 'arrow_downward' }"
          mobile-breakpoint="100"
        >
          <template v-slot:item="{item}">
            <tr class="items-body-row">
              <td>
                <router-link
                  :to="'/unassigned/' + item.id + '/show'"
                  >{{ item.id }}</router-link
                >
              </td>
              <td>
                <router-link
                  :to="!Boolean(item.commercial) ? 
                    `/client/${item.client_id}/show` :
                    `/commercial_client/${item.commercial_client_id}/show?commercial_location_id=${item.commercial_location_id}`"
                  >{{ item.full_name }}</router-link
                >
              </td>
              <td>{{ item.address }}</td>
              <td>{{ item.city }}</td>
              <td>{{ item.zip }}</td>
              <td>
                  <span v-if="!no_data.includes(item.service_plan_name)">{{ item.service_plan_name }}</span>
                  <span v-else-if="no_data.includes(item.service_plan_slug)">One Time</span>
                  <em v-else class="grey--text">No data</em>
              </td>
              <td>{{ item.created_at }}</td>
              <td>
                <v-flex d-flex style="max-width: 72px; margin: 0 auto;">
                  <v-btn icon class="mx-0" @click="showDetails(item.id)">
                    <v-icon color="primary">visibility</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="mx-0"
                    @click="assignLocationModal(item)"
                  >
                    <v-icon color="green">assignment_turned_in</v-icon>
                  </v-btn>
                </v-flex>
              </td>
            </tr>
          </template>
          <template
            slot="no-data"
            v-if="error_code == 404 || error_code == 500"
          >
            <v-btn color="primary" @click="initialize()">Reset</v-btn>
          </template>
        </v-data-table>

        <edit-unassigne-schedule @done="initialize"></edit-unassigne-schedule>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import ApiService from "@/common/api.service";
import EventBus from "@/main";
import EditUnassigneSchedule from "../EditUnassigneSchedule.vue";
import { mapActions } from 'vuex'

export default {
  name: "Unassigned",
  components: {
    EditUnassigneSchedule
  },
  data: () => ({
    no_data: [null, "", undefined, "null"],
    error_code: "",
    headers: [
      { text: "Location ID", value: "id", sort_column: 0 },
      { text: "Client Name", value: "full_name", sort_column: 1 },
      { text: "Address", value: "address", sortable: false },
      { text: "City", value: "city", sortable: false },
      { text: "Zip", value: "zip", sortable: false },
      { text: "Service Plan", value: "service_plan_name", sortable: false },
      { text: "Sign Up Date & Time", value: "created_at", sortable: false },
      { text: "Actions", sortable: false, align: "center" }
    ],
    items: [],
    staff: [],
    totalItems: 0,
    search: "",
    options: {},
    loading: false,
    draw: 0,
    tableData: {
      draw: 0,
      length: 10,
      search: "",
      page: 0,
      column: 0,
      dir: "asc"
    }
  }),

  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      handler() {
        if (this.draw !== this.tableData.draw) {
          this.initialize();
        }
      },
      deep: true
    },
    search: _.debounce(function() {
      this.typing = false;
      if (this.draw !== this.tableData.draw) {
        this.options.page = 1
        this.initialize();
      }
    }, 1000)
  },
  mounted() {
    this.loading = true
    setTimeout(() => {
      this.initialize()
    }, 1000)
  },
  methods: {
    ...mapActions(['vEmit']),
    initialize() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      this.tableData.column = 0;
      if (
        !this.no_data.includes(sortBy) &&
        !this.no_data.includes(sortBy[0]) &&
        this.headers.some(i => i.value === sortBy[0] && i.sortable !== false)
      ) {
        this.tableData.column = this.headers.find(
          i => i.value === sortBy[0]
        ).sort_column;
      }
      this.tableData.dir = !this.no_data.includes(sortDesc) && sortDesc[0] === true ? "asc" : "desc";

      this.tableData.length = itemsPerPage;

      this.tableData.page = page;
      this.tableData.search = this.search;
      this.tableData.draw++;
      this.draw = this.tableData.draw;

      ApiService.get("/scheduler/unassigned", this.tableData)
        .then(response => {
          this.draw++;
          this.items = response.data.locations.data;
          this.totalItems = response.data.locations.total;
          this.loading = false;
        })
        .catch(error => {
          this.error_code = error.response.status;
          console.log(error.message);
        });
    },

    //Assign Location Modal
    assignLocationModal(item) {
      this.vEmit({ name: "AssignLoadLocation", data: item.id })
    },

    showDetails(id) {
      this.$router.push("/unassigned/" + id + "/show");
    },

    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    }
  }
};
</script>
<style scoped>
/**tools table**/
.clients-wrap div.datatable.table {
  margin-bottom: 0%;
}

.dialog-heading {
  background-color: #efefef;
  padding: 10px;
}

td a {
  text-decoration: none;
}
</style>
